// ============================================================
// WEBREX UX FIX - Bloque 4.1
// - Cambia "initialUnchecked" de false a true (no auto-add)
// - Cambia el titulo "You Might Also Like" a "Tal vez pueda interesarte"
// ============================================================
(function patchWebrexUpsell() {
  'use strict';

  function applyPatch() {
    if (typeof window.ws_up_sell === 'undefined' || !Array.isArray(window.ws_up_sell)) return;

    window.ws_up_sell.forEach(function(offer) {
      // Fix 1: No pre-seleccionar productos (evitar auto-add al carrito)
      if (offer.productSelection) {
        offer.productSelection.initialUnchecked = true;
      }

      // Fix 2: Cambiar texto del titulo y subtitulo
      if (offer.upsellDesign && offer.upsellDesign.mainDivSetting) {
        offer.upsellDesign.mainDivSetting.forEach(function(div) {
          if (div.subChild) {
            div.subChild.forEach(function(child) {
              if (child.class === 'ws_header_container' && child.subChild) {
                child.subChild.forEach(function(headerChild) {
                  if (headerChild.class === 'ws_upper_title') {
                    headerChild.textContent = 'Tal vez pueda interesarte';
                    if (headerChild.style) headerChild.style.text = 'Tal vez pueda interesarte';
                  }
                  if (headerChild.class === 'ws_upper_subtitle') {
                    headerChild.textContent = '';
                    if (headerChild.style) headerChild.style.text = '';
                  }
                });
              }
            });
          }
        });
      }
    });
  }

  // Interceptar ws_up_sell usando defineProperty para capturar cuando se setea
  var _wsUpSell = window.ws_up_sell;
  Object.defineProperty(window, 'ws_up_sell', {
    get: function() { return _wsUpSell; },
    set: function(val) {
      _wsUpSell = val;
      // Apply patch immediately after value is set
      setTimeout(applyPatch, 0);
    },
    configurable: true
  });

  // Also apply if already set
  if (window.ws_up_sell) {
    applyPatch();
  }

  // Also patch DOM after render using MutationObserver
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Fix text nodes that say "You Might Also Like"
          var titles = node.querySelectorAll ? node.querySelectorAll('.ws_upper_title') : [];
          titles.forEach(function(el) {
            if (el.textContent.trim() === 'You Might Also Like') {
              el.textContent = 'Tal vez pueda interesarte';
            }
          });
          var subtitles = node.querySelectorAll ? node.querySelectorAll('.ws_upper_subtitle') : [];
          subtitles.forEach(function(el) {
            if (el.textContent.trim() === 'Add more to your order') {
              el.textContent = '';
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also fix existing DOM elements
  document.querySelectorAll('.ws_upper_title').forEach(function(el) {
    if (el.textContent.trim() === 'You Might Also Like') {
      el.textContent = 'Tal vez pueda interesarte';
    }
  });
  document.querySelectorAll('.ws_upper_subtitle').forEach(function(el) {
    if (el.textContent.trim() === 'Add more to your order') {
      el.textContent = '';
    }
  });
})();

// BÚSQUEDA – Sidebar togglable en desktop
// Cierra el panel de filtros al cargar la página en desktop
// para que empiece oculto y el usuario lo abra con el botón.
// ============================================================
(function initTogglableFilters() {
  function closeFiltersOnDesktop() {
      if (window.innerWidth >= 1024) {
            const facets = document.querySelector('#facet-filters');
                  if (facets && facets.hasAttribute('open')) {
                          facets.removeAttribute('open');
                                  facets.setAttribute('aria-hidden', 'true');
                                        }
                                            }
                                              }

                                                if (document.readyState === 'loading') {
                                                    document.addEventListener('DOMContentLoaded', closeFiltersOnDesktop);
                                                      } else {
                                                          closeFiltersOnDesktop();
                                                            }
                                                            })();
